<script>
  import { createEventDispatcher } from "svelte";
  import { onMount } from "svelte";
  import { saySomething } from "./firebase";
  import LoadingSpinner from "./LoadingSpinner.svelte";
  import { bgColor } from "./stores/background_color";

  const dispatch = createEventDispatcher();

  let input;

  let msg = "";

  let loading = false;

  function close() {
    dispatch("close");
  }

  function catchClick(e) {
    e.stopPropagation();
  }

  async function catchEnter(e) {
    if (e.code === "Enter") {
      submit();
    }
  }

  onMount(() => {
    if (!loading) {
      input.focus();
      input.select();
    }
  });

  async function submit() {
    msg.trim();
    if (msg == "") return;
    loading = true;
    await new Promise((resolve) => setTimeout(resolve, 1000));
    await saySomething(msg);
    loading = false;
    close();
  }
</script>

<div class="bg" on:click={close} on:keydown={{}}>
  <div class="box" on:click={catchClick} alt="" on:keydown={{}}>
    {#if loading}
      <LoadingSpinner />
    {:else}
      <input
        placeholder="Say something"
        bind:value={msg}
        bind:this={input}
        on:keydown={catchEnter}
        maxlength="30"
        type="text"
        onsubmit="submit"
      />
      <div
        class="sendBtn"
        style="color: {$bgColor}"
        on:click={submit}
        on:keydown={catchEnter}
      >
        <i class="fa-solid fa-paper-plane"></i>
      </div>
    {/if}
  </div>
</div>

<style>
  .sendBtn {
    font-size: 32px;
    padding: 0px 12px 0px 20px;
  }
  .bg {
    width: 100vw;
    height: 100vh;
    display: flex;
    grid-template-rows: 56px auto;
    position: fixed;
    align-items: center;
    justify-content: center;
    background: #00000085;
    z-index: 9999;
  }

  .box {
    background: #202020ff;
    border-bottom: 2px solid #18181882;
    box-shadow: 0px 0px 5px #000000bf;
    display: flex;
    align-items: center;
    max-width: 300px;
    padding: 8px;
    border-radius: 8px;
  }

  input {
    background: #141414;
    border: 1px solid #0a0a0a;
    border-radius: 4px;
    color: #ffffffe8;
    font-family: "Paytone One", Arial, Helvetica, sans-serif;
    font-size: 18px;
    margin: 0;
    padding: 12px;
    width: 100%;
  }

  input:focus {
    outline: none;
  }
</style>
